import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider
} from '@material-ui/core';

const ApproveAddressModal = ({ open, addressDetails, onApprove, onCancel }) => {
  const {
    originalAddress,
    newAddress,
    jobSite
  } = addressDetails
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Address Update</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" gutterBottom>
          Original Address:
        </Typography>
        <Typography variant="body1" color="textSecondary">{originalAddress}</Typography>

        <Divider style={{ margin: '16px 0' }} />

        <Typography variant="subtitle1" gutterBottom>
          New Address:
        </Typography>
        <Typography variant="body1" color="primary">{newAddress}</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="default">Cancel</Button>
        <Button onClick={onApprove} color="primary" variant="contained">Approve</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveAddressModal;
